module.exports = __webpack_public_path__ + "img/house.7b3afc9a.png";